import { FC, useMemo, useCallback } from 'react';
import { useTheme, Theme } from '@emotion/react';
import { CrownSimple } from '@phosphor-icons/react';
import { AccountUserRole } from 'common/CommonConstants';
import { getPlaceholderUrl } from 'common/commonUtil';
import { useUser } from 'client/lib/User';
import { RadioGroup } from 'client/components/RadioGroup';

export const adminSubtitle = (theme: Theme) => (
  <>
    <CrownSimple weight="fill" color={theme.color.gold} style={{ transform: 'translateY(2px)' }} /> You are an admin
  </>
);
export const memberSubtitle = 'You are a member';

export interface AccountSelectProps {
  accountID: number | null;
  adminOnly?: boolean;
  onChange: (accountID: number) => void;
}

export const AccountSelect: FC<AccountSelectProps> = ({ accountID, adminOnly = false, onChange }) => {
  const { user } = useUser();
  const theme = useTheme();

  const accountItems = useMemo(
    () =>
      (user?.accounts || []).map((account) => ({
        id: `${account.id}`,
        title: account.name,
        subtitle: account.accountUserRoleID === AccountUserRole.ADMINISTRATOR ? adminSubtitle(theme) : memberSubtitle,
        image: { alt: 'account profile picture', src: getPlaceholderUrl('account', account.id) },
        disabled: adminOnly ? account.accountUserRoleID !== AccountUserRole.ADMINISTRATOR : false,
      })),
    [user?.accounts]
  );

  const handleChange = useCallback((value: string) => onChange(parseInt(value)), [onChange]);

  return <RadioGroup value={`${accountID}`} items={accountItems} onChange={handleChange} />;
};
